import { useColorMode } from '@chakra-ui/react';

interface ToastContentBoxProps {
  startElement: React.ReactNode;
  position: 'top' | 'bottom';
  message: string;
  isDarkMode: boolean;
}

const ToastContentBox = ({
  startElement,
  position = 'bottom',
  message,
  isDarkMode = false
}: ToastContentBoxProps) => {
  const { colorMode } = useColorMode();
  const isLightAppearance = !isDarkMode && colorMode === 'light';

  const shadowStyle = isLightAppearance
    ? '0px 0px 5px 0px rgba(0, 0, 0, 0.08), 0px 0px 12px 0px rgba(0, 0, 0, 0.05)'
    : '0px 0px 5px 0px rgba(0, 0, 0, 0.15), 0px 0px 12px 0px rgba(0, 0, 0, 0.20)';

  const backgroundColor = isLightAppearance ? 'bg-black-opacity-500' : 'bg-white-opacity-600';
  const textColor = isLightAppearance ? 'text-pure-white' : 'text-pure-black';

  return (
    <div
      className={`w-full flex justify-center ${position === 'top' ? 'mt-[150px]' : 'mb-[150px]'}`}
    >
      <div
        className={`flex items-center justify-center ${backgroundColor} h-[40px] rounded-[30px] pl-[16px] pr-[18px] py-[12px] gap-[4px]`}
        style={{
          boxShadow: shadowStyle
        }}
      >
        {startElement}
        <p className={`${textColor} text-[14px] font-medium leading-none`}>{message}</p>
      </div>
    </div>
  );
};

export default ToastContentBox;
